import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingSpinner = () => {
    return (
        <Box 
            sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                width: '100%',
                backgroundColor: '#ffffff'
            }}
        >
            <CircularProgress sx={{ color: '#f67d4a' }} />
        </Box>
    );
};

export default LoadingSpinner;
